module.exports = __webpack_public_path__ + "static/media/m_w_hr_12.143ffdda.png";